"use client";
import { useEffect, useRef, useState } from "react";
import { Input } from "antd";
import { useRouter, useSearchParams } from "next/navigation";
import { useInventoryNav } from "./InventoryNavContext";

const { Search } = Input;

export default function SearchBar({ className }: { className?: string }) {
  const router = useRouter();
  const searchParams = useSearchParams();
  // Route search through the shared nav transition so it participates in the same
  // isNavigating signal (and the navigation guard) as every other items control.
  const { isNavigating, runNavigation } = useInventoryNav();
  const [isSearching, setIsSearching] = useState(false);
  const [localSearch, setLocalSearch] = useState(searchParams.get("search") || '');
  const searchBarRef = useRef<any>(null);

  // Spinner only for an actual search; other navigations just disable the input.
  const loading = isSearching;

  // Clear isSearching once the navigation completes
  useEffect(() => {
    if (!isNavigating && isSearching) {
      setIsSearching(false);
      searchBarRef?.current?.blur();
    }
  }, [isNavigating, isSearching]);

  useEffect(() => {
    setLocalSearch(searchParams.get("search") || '');
  }, [searchParams]);

  const onSearch = (value: string) => {
    setIsSearching(true);
    const params = new URLSearchParams(searchParams.toString());
    if (value) {
      params.set("search", value);
    } else {
      params.delete("search");
    }
    runNavigation(() => {
      router.push(`?${params.toString()}`);
    });
  };

  return (
    <Search
      ref={searchBarRef}
      type="search"
      enterButton={false}
      placeholder="Search items..."
      allowClear={true}
      loading={loading}
      disabled={isNavigating}
      suffix={<span />}
      className={className}
      onSearch={onSearch}
      value={localSearch}
      onChange={(e) => setLocalSearch(e.target.value)}
    />
  );
}